import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  addPrivateModal,
  addServiceModal,
} from "../../redux/actions/sidebar/sidebarAction";
import { voiceReviewActionLabel } from "../voiceAdd/saveDraftEdit";

export const StepButton = (props) => {
  const { serviceModal } = useSelector((state) => state.sidebar);
  const dispatch = useDispatch();
  return (
    <>
      <div className="bg-white card-panel ex-space-y pt-0">
        <div className="action-wrapper blk-padding-y">
          <div className="action-inner-block">
            <div className="action-btn-block">
              <button
                type="button"
                className="btn btn-medium btn-transparent"
                onClick={(e) => {
                  !serviceModal
                    ? dispatch(addPrivateModal(false))
                    : dispatch(addServiceModal(false));
                  // history.push('/gym-panel/wod');
                }}
              >
                Cancel
              </button>
              <button
                value="Add Workout"
                className="btn btn-medium"
                type="submit"
              >
                {/* Create WOD */}
                {voiceReviewActionLabel(props.edit ? "Update" : "Create")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
